import consumer from './consumer'

export const subscribeToNotificationChannel = ({ onUpdate }) => {
  consumer.subscriptions.create('NotificationsChannel', {
    initialized () {
      this.update = this.update.bind(this)
    },

    received (notification) {
      this.update(notification)
    },

    update (notification) {
      onUpdate(notification)
    },
  })
}
